@if (label()) {
    <form-label
        [id]="id() + '-textarea'"
        [forId]="id() + '-textarea'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<textarea
    pTextarea
    [id]="id() + '-textarea'"
    [rows]="rows()"
    [(ngModel)]="value"
    [disabled]="disabled()"
    [placeholder]="placeholder() | translate"
    [autoResize]="false"
    [pSize]="size()"
    [fluid]="true"
    [invalid]="invalid()"></textarea>

<div class="counter-container">
    <char-counter [maxLength]="maxLength()" [text]="value()"></char-counter>
</div>
